<div class="main-content">
	<div class="container-fluid">
		<div class="col-md-12">
			<div class="card">
				<div class="card-header card-header-{{color}}-6 d-flex justify-content-between align-items-center">
					<h4 class="card-title mb-0" (click)="backToList()">
						<i class="material-icons">arrow_left</i>
						Payment run #{{ journal }}
					</h4>
					<a routerLink="/vendors-pending-payment-runs" class="btn btn-sm btn-light">Pending payment runs</a>
				</div>
				<div class="card-body">
					<div *ngIf="loading" class="text-center py-5">
						<mat-spinner diameter="40" class="mx-auto"></mat-spinner>
					</div>

					<div *ngIf="!loading && error" class="alert alert-warning">
						{{ error }}
						<button type="button" class="btn btn-sm btn-outline-primary ml-2" (click)="backToList()">Back to pending runs</button>
					</div>

					<ng-container *ngIf="!loading && run && !error">
						<div *ngIf="successMessage" class="alert alert-success mb-3">
							<i class="fa fa-check-circle"></i> {{ successMessage }}
						</div>

						<div class="payment-run-form mb-4" *ngIf="getRemittanceList().length">
							<h5 class="section-heading">Run summary</h5>
							<div class="row g-3">
								<div class="col-md-2">
									<label class="form-label">Currency</label>
									<div class="form-control form-control-sm bg-light">{{ getRunSummaryCurrency() }}</div>
								</div>
								<div class="col-md-2">
									<label class="form-label">Vendors</label>
									<div class="form-control form-control-sm bg-light">{{ getRunSummaryVendorCount() }}</div>
								</div>
								<div class="col-md-2">
									<label class="form-label">Transactions</label>
									<div class="form-control form-control-sm bg-light">{{ getRunSummaryTransactionCount() }}</div>
								</div>
								<div class="col-md-3">
									<label class="form-label">Bank account</label>
									<div class="form-control form-control-sm bg-light">{{ run.savedPayload?.bankacct || '—' }}</div>
								</div>
							</div>
						</div>

						<div *ngIf="!getRemittanceList().length" class="alert alert-info">No remittance lines in this run.</div>

						<div *ngIf="getRemittanceList().length" class="vendor-container">
							<div class="transaction-header">
								<div class="transaction-checkbox" *ngIf="editMode">
									<label class="mb-0">Select all</label>
									<label class="group-select-all">
										<input type="checkbox" class="group-select-all-input" [checked]="allLinesSelected()" (change)="setAllLinesSelection($any($event.target).checked)">
										<span class="group-select-all-checkmark"></span>
									</label>
								</div>
								<div class="transaction-checkbox" *ngIf="!editMode"></div>
								<div class="transaction-details mt-2">Transaction details</div>
								<div class="transaction-dates mt-2">Date</div>
								<div class="transaction-amounts">Amount</div>
								<div class="transaction-discount">Discount</div>
								<div class="transaction-amount-due">Amount due</div>
							</div>

							<div *ngFor="let rem of getDisplayRemittance()" class="vendor-group card-header mt-0 mb-0">
								<div class="row mt-0 mb-0 align-items-end">
									<div class="col-4 text-left">
										<label class="mb-0">Vendor</label>
										<h4 class="mb-0"><b>{{ rem.SupplierID }} {{ rem.PayOrder }}</b></h4>
									</div>
									<div class="col-1 text-center group-select-all-cell" *ngIf="editMode">
										<label class="mb-0">Select all</label>
										<label class="group-select-all">
											<input type="checkbox" class="group-select-all-input" [checked]="allVendorLinesSelected(rem)" (change)="setVendorSelection(rem, $any($event.target).checked)">
											<span class="group-select-all-checkmark"></span>
										</label>
									</div>
									<div class="col-3 text-center" [class.col-4]="!editMode">
										<label class="mb-0">Payment date</label>
										<div class="form-control form-control-sm bg-light text-center">{{ rem.PostDate || '—' }}</div>
									</div>
									<div class="col-3 text-center">
										<label class="mb-0">Ref #</label>
										<div class="form-control form-control-sm bg-light text-center">{{ rem.PaytReference }}</div>
									</div>
								</div>
								<div class="row mt-1 mb-2 vendor-payment-type-row">
									<div class="col-12">
										<label class="vendor-payment-type-row__label">Payment type</label>
										<div class="vendor-payment-type">
											<span class="vendor-payment-type__option vendor-payment-type__option--selected">{{ rem.PaytType || 'Check' }}</span>
										</div>
									</div>
								</div>

								<div *ngFor="let line of rem.lines" class="transaction-row" [class.review-line-unchecked]="editMode && !line.selected">
									<div class="transaction-checkbox" *ngIf="editMode">
										<label class="custom-checkbox">
											<input type="checkbox" [(ngModel)]="line.selected">
											<span class="checkmark"></span>
										</label>
									</div>
									<div class="transaction-checkbox" *ngIf="!editMode"></div>
									<div class="transaction-details">
										<b class="transaction-reference">{{ line.suppreference || '—' }}</b>
									</div>
									<div class="transaction-dates">
										<span class="transaction-dates-values">{{ line.trandate || '—' }}</span>
									</div>
									<div class="transaction-amounts">
										<div class="amount-item">
											<span class="amount-value">${{ line.amount | number: '1.2-2' }}</span>
										</div>
									</div>
									<div class="transaction-discount">
										<span class="amount-value">${{ line.discount | number: '1.2-2' }}</span>
									</div>
									<div class="transaction-amount-due">
										<span class="amount-value">${{ (line.amount || 0) + (line.discount || 0) | number: '1.2-2' }}</span>
									</div>
								</div>
								<div class="vendor-total">
									<h5>Total for {{ rem.SupplierID }}: ${{ getVendorTotal(rem) | number: '1.2-2' }}</h5>
								</div>
							</div>

							<div class="payment-summary-floater">
								<div class="payment-summary-floater__card">
									<div class="payment-summary-floater__header" (click)="toggleSummary()">
										<span class="payment-summary-floater__title">{{ getRunSummaryCurrency() }} ${{ getRunSummaryTotal() | number: '1.2-2' }}</span>
										<button class="payment-summary-floater__toggle" type="button" (click)="toggleSummary(); $event.stopPropagation()" [attr.aria-label]="summaryCollapsed ? 'Show details' : 'Hide details'">
											<mat-icon>{{ summaryCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
										</button>
									</div>
									<div class="payment-summary-floater__body" *ngIf="!summaryCollapsed">
										<div class="payment-summary-floater__row">
											<span class="payment-summary-floater__label">Discounts</span>
											<span class="payment-summary-floater__value">{{ getRunSummaryCurrency() }} ${{ getRunSummaryDiscount() | number: '1.2-2' }}</span>
										</div>
										<div class="payment-summary-floater__row">
											<span class="payment-summary-floater__label">Transactions</span>
											<span class="payment-summary-floater__value">{{ getRunSummaryTransactionCount() }}</span>
										</div>
										<div class="payment-summary-floater__actions">
											<button type="button" class="btn btn-danger btn-sm w-100 mb-2" (click)="printPdf()" [disabled]="editMode || !getRemittanceList().length">
												<i class="fa fa-file-pdf-o"></i> Print PDF
											</button>
											<button type="button" class="btn btn-success btn-sm w-100 mb-2" (click)="exportXls()" [disabled]="editMode || !getRemittanceList().length">
												<i class="fa fa-file-excel-o"></i> Export XLS
											</button>
											<button *ngIf="!editMode && run.savedPayload && getRemittanceList().length" type="button" class="btn btn-outline-primary btn-sm w-100 mb-2" (click)="enterEditMode()">
												<i class="fa fa-pencil"></i> Edit run
											</button>
											<ng-container *ngIf="editMode">
												<button type="button" class="btn btn-outline-secondary btn-sm w-100 mb-2" (click)="cancelEdit()">Cancel edit</button>
												<button type="button" class="btn btn-primary btn-sm w-100 mb-2" (click)="resave()" [disabled]="!canResave()">
													Resave
													<mat-spinner *ngIf="saving" diameter="18" class="ml-1 d-inline-block vertical-align-middle"></mat-spinner>
												</button>
											</ng-container>
											<button type="button" class="btn btn-success btn-sm w-100" (click)="approveAndPost()" [disabled]="posting || (editMode && !canPostFromEdit())">
												<i class="fa fa-check-circle"></i> Approve & post
												<mat-spinner *ngIf="posting" diameter="18" class="ml-1 d-inline-block vertical-align-middle"></mat-spinner>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-container *ngIf="run && getRemittanceList().length">
	<div #paymentRunPrintArea class="d-none" style="font-size: 10pt;">
		<h3>Payment Run #{{ journal }}</h3>
		<div *ngFor="let rem of getRemittanceList()">
			<p><strong>{{ rem.SupplierID }}</strong> {{ rem.PayOrder }} &nbsp; {{ rem.PaytType }} &nbsp; Ref #{{ rem.PaytReference }} &nbsp; {{ rem.PostDate }} &nbsp; {{ rem.Currency }} {{ rem.AccumBalance | number: '1.2-2' }}</p>
			<table style="width:100%; border-collapse: collapse; margin-bottom: 1em;">
				<thead>
					<tr style="background: #f0f0f0;">
						<th style="border: 1px solid #ccc; padding: 4px; text-align: left;">Reference</th>
						<th style="border: 1px solid #ccc; padding: 4px; text-align: left;">Date</th>
						<th style="border: 1px solid #ccc; padding: 4px; text-align: right;">Amount</th>
						<th style="border: 1px solid #ccc; padding: 4px; text-align: right;">Discount</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let line of rem.lines" style="border: 1px solid #ccc;">
						<td style="border: 1px solid #ccc; padding: 4px;">{{ line.suppreference || '—' }}</td>
						<td style="border: 1px solid #ccc; padding: 4px;">{{ line.trandate || '—' }}</td>
						<td style="border: 1px solid #ccc; padding: 4px; text-align: right;">{{ line.amount | number: '1.2-2' }}</td>
						<td style="border: 1px solid #ccc; padding: 4px; text-align: right;">{{ line.discount | number: '1.2-2' }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</ng-container>
